import { useState, useEffect, useCallback } from 'react';
import { useHistory, useLocation } from 'quartz-routing/react-router';
const useSettledUrl = ({
  actualSlug,
  urlSlug
}) => {
  const [isSettled, setIsSettled] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const replaceSlug = useCallback((actual, url) => {
    history.replace(location.pathname.replace(actual, url));
  }, [history, location.pathname]);
  useEffect(() => {
    if (!isSettled && typeof urlSlug === 'string') {
      if (urlSlug !== actualSlug) {
        replaceSlug(actualSlug, urlSlug);
      }
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setIsSettled(true);
    }
  }, [actualSlug, isSettled, replaceSlug, urlSlug]);
  return isSettled;
};
export default useSettledUrl;